import authInstance from './auth/authClient';
import AuthUser from './auth';
import Geofence from './geofence';
import Campaign from './campaign';
import instance from './client';

export const AuthUserApi = new AuthUser(authInstance);
export const GeofenceApi = new Geofence(instance);
export const CampaignApi = new Campaign(instance);
